import axios from 'axios'

export default {
  namespaced: true,

  state: {
    countries: [],
    count: 0
  },

  getters: {
    countries (state) {
      return state.countries
    }
  },

  mutations: {
    SET_COUNTRIES (state, countries) {
      state.countries = countries
    },

    SET_COUNT (state, count) {
      state.count = count[0].total
    },

    UPDATE_COUNTRY (state, country) {
      let index = state.countries
        .findIndex((row) => { return row.id === country.id })
      if (index !== -1) {
        state.countries[index] = country
      }
    },

    DELETE_COUNTRY (state, id) {
      let index = state.countries
        .findIndex((row) => { return row.id === id })

      if (index !== -1) {
        state.countries.splice(index, 1)
      }
    }
  },

  actions: {
    async get ({ commit }, params) {
      let countries = await axios.get('/countries', { params })
      let count = await axios.get('/countries/count', { params })

      commit('SET_COUNTRIES', countries.data)
      commit('SET_COUNT', count.data)
    },

    async create ({ commit }, countries) {
      let data = new FormData()

      for (const key in countries) {
        if (!countries.hasOwnProperty(key)) {
          continue
        }

        data.append(key, countries[key])
      }

      let result = await axios.post('/countries', data)
      return result
    },

    async update ({ commit }, country) {
      let data = new FormData()

      for (const key in country) {
        if (!country.hasOwnProperty(key)) {
          continue
        }

        data.append(key, country[key])
      }

      let result = await axios
        .patch(`/countries/${country.id}`, data)

      commit('UPDATE_COUNTRY', country)
      return result
    },

    async delete ({ commit }, id) {
      await axios.delete(`/countries/${id}`)
      commit('DELETE_COUNTRY', id)
    }
  }
}
